.host {
  width: 100%;
  max-width: 39rem;
}
